exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/app/shared/components/forms/autocomplete-field/autocomplete-field.component.css
// module id = ../../../../../src/app/shared/components/forms/autocomplete-field/autocomplete-field.component.css
// module chunks = main